export default __webpack_public_path__ + "static/StowarzyszenieProducentówPolskiejAnimacji-d6cb254f8781d07fc98d783b9f9c4adf.jpg";